/**
 * 获取一个默认的item,包含了所有的字段，但使用时不需要全使用了
 */
export function getDefaultItem() {
  return {
    dataSource:'MANUAL',
    subContractId:0,
    partyB: "",
    contractContent: "",
    settleAmount: undefined,
    cost: undefined,
    taxBillAmount: undefined,
    noTaxBillAmount: undefined,
    taxNoBillAmount: undefined,
    taxRateCurrent: undefined,
    noTaxNoBillAmount: undefined,
    alreadyPay: undefined,
    debtAmount: undefined,
    alreadyPayPct: undefined,
    thisPay: undefined,
    thisPayPct: undefined,
    remark: "",
    serialNumber: undefined,
    amount: undefined
  };
}

/**
 * 默认的sum，包含了所有的字段，但使用时不需要全使用了
 * @returns
 */
export function getDefaultSum() {
  return {
    settleAmount: undefined, //结算金额
    cost: undefined,
    taxBillAmount: undefined,
    noTaxBillAmount: undefined,
    taxNoBillAmount: undefined,
    taxRateCurrent: undefined,
    noTaxNoBillAmount: undefined,
    alreadyPay: undefined,
    debtAmount: undefined,
    alreadyPayPct: undefined,
    thisPay: undefined,
    thisPayPct: undefined,
    remark: "",
    actNoTaxAmount: undefined
  };
}

export function isNil(value) {
  return value == undefined || value == null;
}

export function isNotNil(value) {
  return isNil(value) == false;
}

export function createCollectionItemDefaultTableItem() {
  return {
    number: '', // 期数
    finishPrice: undefined, //完成产值
    calculatePrice: undefined,//计量金额
    applyTime: undefined,//申请日期
    replyPrice: undefined,//批复金额
    replyTime: undefined,//批复时间
    billPrice: undefined,//开具发票金额
    outputTaxPrice: undefined,//销项税金额
    receiptPrice: undefined,//收款金额.
    finishPriceRate: undefined,//完成产值占合同比例
    calculatePriceRate: undefined,//计量金额占合同比例
    replyPriceRate: undefined,//已批复产值占合同比例
    receiptPriceRate: undefined,//已收款占合同额比例
    receiptPlanPrice: undefined,//应收账款
  }
}

export const tabIndex = [
  {
    id: 0,
    label: "全部",
    name: "first",
  },
  {
    id: 1,
    label: "待审核",
    name: "second",
  },
  {
    id: 2,
    label: "已通过",
    name: "third",
  },
  {
    id: 3,
    label: "已驳回",
    name: "fourth",
  },
];

export function getTabIndex(name) {
  let result = tabIndex.find(tab => tab.name == name);
  return result ? result.id : undefined
}

// 每隔3位加个逗号隔开,并且要小数点后面要留两位
export function formatMoney(moneyValue) {
  let valueFloat = parseFloat(moneyValue);
  if(isNaN(valueFloat)) {
    return '';
  }
  let valueStr = valueFloat.toFixed(2);
  let index = valueStr.indexOf('.');
  let diff = valueStr.substring(index, valueStr.length);
  let valueInt = parseInt(valueStr);
  let str = valueInt.toLocaleString();
  str = str + diff;
  return str;
}

// 数字后面加%
export function formatPercent(value, isPct = true) {
  let valueFloat = parseFloat(value);
  if(isNaN(valueFloat)) {
    return ''
  }
  if(isPct) {
    return valueFloat ? valueFloat.toFixed(2) + ' %' : '0 %';
  }
  return valueFloat ? (valueFloat * 100).toFixed(2) + ' %' : '0 %';

  
}
